import ActionType from 'actions/ActionType'

export default (state = { index: 0 }, action) => {
	const switchObj = {
		[ActionType.Campaign.ADD_PLACEHOLDER_TASK]: () => {
			return {
				...state,
				[`placeholder_${state.index}`]: {
					...(action?.payload || {}),
					id: `placeholder_${state.index}`,
				},
				index: state.index + 1,
			}
		},
		[ActionType.Campaign.RECEIVE_CAMPAIGN]: () => {
			if (action?.payload) {
				return state
			}
			return { index: 0 }
		},
	}

	return switchObj?.[action?.type] ? switchObj[action?.type]() : state
}
